import { APIHelper } from "../Apis/APIHelper";
import { error, success, warning } from "../Components/custom-toast/CustomToast";
import { useEffect } from "react";
import _ from "lodash";
import { toast } from "react-toastify";

export const verifyLogin = async (userName, password, setObjectDto, setLoading, setLogin) => {
    if (userName !== undefined && password !== undefined && userName !== '' && password !== '') {
        const body = {
            "mesgId": "CUSTOMER_MESG_00000045",
            "obj": {
                "userName": userName,
                "password": password
            }
        };
        const data = await APIHelper.postDataNoAuthen(body);
        if (data !== 'ERR') {
            if (data.code === "1") {
                const objData = data.objData;
                setLoading(false);
                setObjectDto({ fullName: objData.fullName, poIdNumber: objData.username });
                localStorage.setItem("aaa", JSON.stringify({ fullName: objData.fullName, poIdNumber: objData.username }));
                const token = { tokenId: objData.tokenId, exprDate: objData.exprDate }
                return localStorage.setItem('token', JSON.stringify(token));
                // return localStorage.setItem('sessionTimeout', 1800);
            } else if (data.code === "0") {
                if (data.message !== "") {
                    warning(data.message, Date.now() + "wrong username");
                    setLogin(prev => ({...prev, password: ""}));
                } else error("Hệ thống đang mất kết nối, vui lòng thử lại sau!", Date.now() + "server-disconnect");
                setLoading(false);
            }
        } else {
            error("Không kết nối được server, vui lòng tải lại trang và thử lại", Date.now() + "server-fail");
        }
    } else {
        warning("Vui lòng nhập đầy đủ CMND/CCCD/Hộ chiếu và Số điện thoại", Date.now() + "null-data");
    }
    setLoading(false);
}


//get Phone by Id
export const getPoPhone = async (poIdNumber) => {
    const body = {
        "mesgId": "CUSTOMER_MESG_00000001",
        "obj": {
            "poIdNumber": poIdNumber
        }
    };
    const data = await APIHelper.postDataBasic(body);
    if (data !== 'ERR') {
        if (data.code === "1") {
            const jsonData = data.jsonData;
            return jsonData.poPhone;
        } else {
            warning("Lỗi hệ thống", "system-error");
        }
    } else {
        warning("Không kết nối được server, vui lòng tải lại trang và thử lại");
    }
}

export const verifyRegister = async (poIdNumber, setObjectDto, setLoading) => {
    const body = {
        mesgId: "CUSTOMER_MESG_00000055",
        obj: {
            poNumber: "",
            poIdNumber: poIdNumber,
            poPhone: ""
        }
    };
    const data = await APIHelper.postDataNoAuthen(body);
    setLoading(false);
    if (data !== 'ERR') {
        if (data.code === "1") {
            const objData = data.objData;
            if (objData != null) {
                console.log(objData);
                const objectDto = { poIdNumber: objData.poIdNumber, otp: objData.message, poPhone: objData.poPhone, minute: objData.minute }
                setObjectDto(objectDto);
                return localStorage.setItem("aaa", JSON.stringify(objectDto));
            } else {
                return;
            }
        } else {
            warning(data.message, Date.now() + "server-fail");
        }
    } else {
        return error("Không kết nối được server, vui lòng tải lại trang và thử lại", Date.now() + "server-fail");;
    }
}


export const verifyOtpRegister = async (objectDto, setObjectDto, token, setLoading) => {
    const body = {
        mesgId: "CUSTOMER_MESG_00000048",
        obj: {
            "poIdNumber": objectDto.poIdNumber,
            "phone": objectDto.poPhone,
            "token": token
        }
    };
    const data = await APIHelper.postDataNoAuthen(body);
    if (data !== 'ERR') {
        if (data.code === "1") {
            const objData = data.objData;
            if (objData.checked === 1) {
                setLoading(false);
                toast.dismiss();
                setObjectDto({ ...objectDto, fullname: objData.poName, verifiedOTP: "1" });
                localStorage.setItem("aaa", JSON.stringify(objectDto));
                return true;
            } else {
                const count = localStorage.getItem("countWrongOtp");
                setLoading(false);
                if (count < 3) warning("Mã OTP sai, vui lòng thử lại", Date.now() + "wrong-otp");
                return false;
            }
        } else {
            warning(data.message, Date.now() + "wrong-otp");
            return false;
        }
    } else {
        error("Không kết nối được server, vui lòng tải lại trang và thử lại", Date.now() + "server-fail");
    }
    setLoading(false);
    return alert("Lỗi hệ thống");
}

export const createNewAccount = async (objectDto, password, setPassword, setLoading) => {
    setLoading(false);
    if (password.pass === password.rePass) {
        const body = {
            mesgId: "CUSTOMER_MESG_00000002",
            obj: {
                "userName": objectDto.poIdNumber,
                "fullName": objectDto.fullname,
                "password": password.pass
            }
        };
        const data = await APIHelper.postDataNoAuthen(body);
        setLoading(false)
        if (data !== 'ERR') {
            if (data.code === "1") {
                success("Kích hoạt tài khoản thành công")
                return true;
            } else {
                warning(data.message, Date.now() + "server-fail");
                return false;
            }
        } else {
            error("Không kết nối được server, vui lòng tải lại trang và thử lại", Date.now() + "server-fail");
            return false;
        }
    } else {
        warning("Mật khẩu không khớp, vui lòng nhập lại");
        setPassword({ ...password, pass: "", rePass: "" })
        return false;
    }
}

export const verifyResetPassword = async (poIdNumber, setObjectDto, setLoading) => {
    const body = {
        mesgId: "CUSTOMER_MESG_00000049",
        obj: {
            poIdNumber: poIdNumber
        }
    };
    const data = await APIHelper.postDataNoAuthen(body);
    setLoading(false);
    if (data !== 'ERR') {
        if (data.code === "1") {
            const objData = data.objData;
            if (objData != null) {
                console.log(objData);
                const objectDto = { poIdNumber: objData.poIdNumber, otp: objData.message, poPhone: objData.poPhone, minute: objData.minute }
                setObjectDto(objectDto);
                return localStorage.setItem("aaa", JSON.stringify(objectDto));
            } else {
                return;
            }
        } else {
            warning(data.message, Date.now() + "server-fail");
        }
    } else {
        return error("Không kết nối được server, vui lòng tải lại trang và thử lại", Date.now() + "server-fail");;
    }
}

export const verifyOtpResetPassword = async (objectDto, setObjectDto, token, setLoading) => {
    const body = {
        mesgId: "CUSTOMER_MESG_00000048",
        obj: {
            "poIdNumber": objectDto.poIdNumber,
            "phone": objectDto.poPhone,
            "token": token
        }
    };
    const data = await APIHelper.postDataNoAuthen(body);
    if (data !== 'ERR') {
        if (data.code === "1") {
            const objData = data.objData;
            if (objData.checked === 1) {
                setLoading(false);
                toast.dismiss();
                setObjectDto({ ...objectDto, fullname: objData.poName, verifiedOTP: "1" });
                localStorage.setItem("aaa", JSON.stringify(objectDto));
                return true;
            } else {
                const count = localStorage.getItem("countWrongOtp");
                setLoading(false);
                if (count < 3) warning("Mã OTP sai, vui lòng thử lại", Date.now() + "wrong-otp");
                return false;
            }
        } else {
            warning(data.message, Date.now() + "wrong-otp");
            return false;
        }
    } else {
        error("Không kết nối được server, vui lòng tải lại trang và thử lại", Date.now() + "server-fail");
    }
    setLoading(false);
    return alert("Lỗi hệ thống");
}


export const resetPassword = async (objectDto, password, setPassword, setLoading) => {
    setLoading(false);
    if (password.pass === password.rePass) {
        const body = {
            mesgId: "CUSTOMER_MESG_00000050",
            obj: {
                "userName": objectDto.poIdNumber,
                "password": password.pass
            }
        };
        const data = await APIHelper.postDataNoAuthen(body);
        setLoading(false)
        if (data !== 'ERR') {
            if (data.code === "1") {
                success("Tạo lại mật khẩu thành công")
                return true;
            } else {
                warning(data.message, Date.now() + "server-fail");
                return false;
            }
        } else {
            error("Không kết nối được server, vui lòng tải lại trang và thử lại", Date.now() + "server-fail");
            return false;
        }
    } else {
        warning("Mật khẩu không khớp, vui lòng nhập lại");
        setPassword({ ...password, pass: "", rePass: "" })
        return false;
    }
}


export const getAccountInfo = async (objectDto, setObjectDto, setAccount) => {
    const body = {
        mesgId: "CUSTOMER_MESG_00000046",
        obj: objectDto
    };
    const bearerToken = JSON.parse(localStorage.getItem("token")).tokenId;
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    if (data === 401) {
        LogOut(setObjectDto);
        return setAccount(null)
    }
    if (data !== 'ERR') {
        if (data.code === "1") {
            const jsonData = JSON.parse(data.jsonData);
            return setAccount(jsonData);
        }
    } else {
        warning("Không kết nối được tới server", Date.now() + "serverfail");
    }
    return alert("Lỗi hệ thống");
}

export const getPolicyListById = async (objectDto, setObjectDto, setListPolicy) => {
    const body = {
        mesgId: "CUSTOMER_MESG_00000004",
        obj: objectDto
    };
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    if (data === 401) {
        LogOut(setObjectDto);
        warning("Thời gian kết nối tới máy chủ đã hết hạn! Vui lòng đăng nhập lại để tiếp tục!", Date.now() + "server-timeout");
        return ''
    }
    if (data !== 'ERR') {
        if (data.code === "1") {
            const jsonData = JSON.parse(data.jsonData);
            if (jsonData.length === 0) return setListPolicy(null)
            return setListPolicy(jsonData);
        }
    } else {
        warning("Không kết nối được tới server", Date.now() + "serverfail");
    }
    return alert("Lỗi hệ thống");
}

export const getPolicyDetailByPoNumber = async (poNumber, setObjectDto, setInfo) => {
    const poIdNumber = JSON.parse(localStorage.getItem("aaa")).poIdNumber;
    const body = {
        mesgId: "CUSTOMER_MESG_00000005",
        obj: {
            "poNumber": poNumber,
            "client": "1",
            "product": "1",
            "poIdNumber": poIdNumber
        }
    };
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    if (data === 401) {
        LogOut(setObjectDto);
        return setInfo(null);
    }
    if (data !== 'ERR') {
        if (data.code === "1") {
            const jsonData = JSON.parse(data.jsonData);
            if (jsonData === "" || jsonData === null) {
                error("Không tìm thấy hồ sơ", Date.now() + "not-found");
                return setInfo("");
            }
            return setInfo(jsonData);
        }
    } else {
        return warning("Không kết nối được tới server", Date.now() + "serverfail");
    }
    return alert("Lỗi hệ thống");
}

export const ManageCustomer = (objectDto, setObjectDto) => {

    useEffect(() => {
        // const token = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")) : null;
        // if (token !== null) {
        if (_.isEmpty(objectDto)) {
            const user = localStorage.getItem("aaa") !== null ? JSON.parse(localStorage.getItem("aaa")) : null;
            if (user !== null) {
                setObjectDto(user);
            }
        }
    }, []);

    useEffect(() => {
        if (objectDto !== undefined && !_.isEmpty(objectDto)) {
            localStorage.setItem("aaa", JSON.stringify(objectDto));
        }
    }, [objectDto]);
}

export const LogOut = (setObjectDto) => {
    document.title = "Phu Hung Life"
    localStorage.removeItem("aaa");
    localStorage.removeItem("token");
    // localStorage.removeItem("sessionTimeout");
    setObjectDto({});
}

export const HandleException401 = (error, setObjectDto) => {
    if (error.response.status === 401) {
        LogOut(setObjectDto);
        return true;
    } else {
        return false;
    }
}

export const changePassword = async (password, newPassword, setLoading, setInfo) => {
    const body = {
        mesgId: "CUSTOMER_MB_MESG_00000012",
        obj: {
            "currentPassword" : password,
            "newPassword" : newPassword
        }
    };
    const bearerToken = localStorage.getItem("token") !== null ? JSON.parse(localStorage.getItem("token")).tokenId : "";
    const data = await APIHelper.postDataCustomer(body, bearerToken);
    setLoading(false);
    if (data !== 'ERR') {
        if (data.code === "1") {
            success(data.message);
            setInfo(prev => prev.map(item => ({
                ...item,      
                value: "",     
                show: false    
            })));
            return true;
        } else {
            warning(data.message, Date.now() + "server-fail");
            return false;
        }
    } else {
        error("Không kết nối được server, vui lòng tải lại trang và thử lại", Date.now() + "server-fail");
        return false;
    }
}

// export const HandleTimeExpired = (setObjectDto) => {
//     const navigation = useNavigate();
//     var time = localStorage.getItem('sessionTimeout') !== null ? JSON.parse(localStorage.getItem('sessionTimeout')) : null;
//     const [counter, setCounter] = useState(time !== null ? time : 0); //time(s)
//     const objectDto = localStorage.getItem('aaa') !== null ? JSON.parse(localStorage.getItem('aaa')) : null;
//     const token = localStorage.getItem('token') !== null ? JSON.parse(localStorage.getItem('token')) : null;
//     useEffect(() => {
//         const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
//         localStorage.setItem('sessionTimeout', JSON.stringify(counter));
//         if (counter === 0 || objectDto === null || token === null) {
//             // if (counter === 0 || objectDto === null) {
//             navigation("/")
//             LogOut(setObjectDto);
//             warning("Hết hạn kết nối đến server, vui lòng đăng nhập lại để tiếp tục", Date.now() + "count-down-server");
//         }
//         return () => clearInterval(timer);
//     }, [counter]);
// }